import React from "react"

// components
import { Button, Modal, Form, Input, message } from "antd"
import { LoginOutlined } from "@ant-design/icons"

// firebase
import { Auth } from "services/firebase"
import { sendPasswordResetEmail } from "firebase/auth"

// i18n
import { useTranslation } from "react-i18next"

const ResetModal = ({ open, onCancel }) => {
  const [resetForm] = Form.useForm()
  const [isLoading, setIsLoading] = React.useState(false)
  const { t } = useTranslation()

  return (
    <Modal
      title={t("reset_password")}
      footer={null}
      open={open}
      onCancel={onCancel}
    >
      <Form
        form={resetForm}
        name="reset"
        layout="vertical"
        onFinish={async (values) => {
          try {
            setIsLoading(true)
            await sendPasswordResetEmail(Auth, values.email.trim())
            onCancel()
            resetForm.resetFields()
          } catch (e) {
            message.error(e.message)
            console.error(e)
          } finally {
            setIsLoading(false)
          }
        }}
      >
        <Form.Item
          label={t("email")}
          name="email"
          rules={[
            {
              required: true,
              message: t("reset_email_required"),
            },
          ]}
        >
          <Input autoComplete="email" />
        </Form.Item>

        <Form.Item>
          <Button
            icon={<LoginOutlined />}
            type="primary"
            htmlType="submit"
            loading={isLoading}
          >
            {t("reset_password")}
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  )
}

export default ResetModal
